module.exports = __webpack_public_path__ + "static/5-cd5ad40f26ad0be8370eac8a23ba030d.jpg";